/* TP Gallery Mobile — swipeable + pinch/double-tap zoom for the product
   media modal on phones. Author: Codani Impex SRL / TotalPantofi.ro
   No-ops entirely above the 749px breakpoint so desktop behaviour (owned
   by Dawn's product-modal.js) is untouched. */
(function () {
  if (window.tpGalleryModalLoaded) return;
  window.tpGalleryModalLoaded = true;

  var mql = window.matchMedia('(max-width: 749px)');
  var MAX_SCALE = 4;
  var DOUBLE_TAP_SCALE = 2.4;
  var DOUBLE_TAP_MS = 300;
  var DOUBLE_TAP_SLOP = 24;
  var CLOSE_DRAG_THRESHOLD = 90;

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function touchDistance(t1, t2) {
    var dx = t1.clientX - t2.clientX;
    var dy = t1.clientY - t2.clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function ZoomableImage(frame) {
    this.frame = frame;
    this.img = frame.querySelector(':scope > img');
    if (!this.img) return;

    this.scale = 1;
    this.translateX = 0;
    this.translateY = 0;
    this.pinchStartDistance = 0;
    this.pinchStartScale = 1;
    this.panStartX = 0;
    this.panStartY = 0;
    this.panStartTranslateX = 0;
    this.panStartTranslateY = 0;
    this.mode = null;
    this.lastTapTime = 0;
    this.lastTapX = 0;
    this.lastTapY = 0;
    this.touchStartX = 0;
    this.touchStartY = 0;

    this.onTouchStart = this.onTouchStart.bind(this);
    this.onTouchMove = this.onTouchMove.bind(this);
    this.onTouchEnd = this.onTouchEnd.bind(this);

    this.img.addEventListener('touchstart', this.onTouchStart, { passive: false });
    this.img.addEventListener('touchmove', this.onTouchMove, { passive: false });
    this.img.addEventListener('touchend', this.onTouchEnd, { passive: true });
    this.img.addEventListener('touchcancel', this.onTouchEnd, { passive: true });
  }

  ZoomableImage.prototype.apply = function () {
    var value = 'translate(' + this.translateX + 'px, ' + this.translateY + 'px) scale(' + this.scale + ')';
    this.img.style.setProperty('transform', value, 'important');
    this.frame.classList.toggle('tp-zoomed', this.scale > 1.02);
  };

  ZoomableImage.prototype.reset = function () {
    this.scale = 1;
    this.translateX = 0;
    this.translateY = 0;
    this.img.style.setProperty('transform-origin', 'center center', 'important');
    this.apply();
  };

  ZoomableImage.prototype.clampTranslate = function () {
    var rect = this.img.getBoundingClientRect();
    var frameRect = this.frame.getBoundingClientRect();
    var overflowX = Math.max(0, (rect.width - frameRect.width) / 2);
    var overflowY = Math.max(0, (rect.height - frameRect.height) / 2);
    this.translateX = clamp(this.translateX, -overflowX, overflowX);
    this.translateY = clamp(this.translateY, -overflowY, overflowY);
  };

  ZoomableImage.prototype.onTouchStart = function (event) {
    if (!mql.matches) return;
    if (event.touches.length === 2) {
      this.mode = 'pinch';
      this.pinchStartDistance = touchDistance(event.touches[0], event.touches[1]);
      this.pinchStartScale = this.scale;
      event.preventDefault();
    } else if (event.touches.length === 1) {
      this.touchStartX = event.touches[0].clientX;
      this.touchStartY = event.touches[0].clientY;
      if (this.scale > 1.02) {
        this.mode = 'pan';
        this.panStartX = event.touches[0].clientX;
        this.panStartY = event.touches[0].clientY;
        this.panStartTranslateX = this.translateX;
        this.panStartTranslateY = this.translateY;
      } else {
        this.mode = null;
      }
    }
  };

  ZoomableImage.prototype.onTouchMove = function (event) {
    if (!mql.matches) return;
    if (this.mode === 'pinch' && event.touches.length === 2) {
      event.preventDefault();
      if (this.pinchStartDistance > 0) {
        var currentDistance = touchDistance(event.touches[0], event.touches[1]);
        this.scale = clamp(this.pinchStartScale * (currentDistance / this.pinchStartDistance), 1, MAX_SCALE);
        this.clampTranslate();
        this.apply();
      }
    } else if (this.mode === 'pan' && event.touches.length === 1) {
      event.preventDefault();
      var dx = event.touches[0].clientX - this.panStartX;
      var dy = event.touches[0].clientY - this.panStartY;
      this.translateX = this.panStartTranslateX + dx;
      this.translateY = this.panStartTranslateY + dy;
      this.clampTranslate();
      this.apply();
    }
  };

  ZoomableImage.prototype.onTouchEnd = function (event) {
    if (!mql.matches) return;
    if (this.mode === 'pinch') {
      if (this.scale <= 1.02) this.reset();
      this.mode = null;
      return;
    }
    // A tap while zoomed starts life as 'pan' mode (see onTouchStart), but if
    // the finger never actually moved it's still a tap — fall through so a
    // double-tap can be recognised and toggle the zoom back off.
    this.mode = null;

    var changed = event.changedTouches && event.changedTouches[0];
    if (!changed) return;

    var dx = Math.abs(changed.clientX - this.touchStartX);
    var dy = Math.abs(changed.clientY - this.touchStartY);
    if (dx >= 10 || dy >= 10) return;

    var now = Date.now();
    var dtx = Math.abs(changed.clientX - this.lastTapX);
    var dty = Math.abs(changed.clientY - this.lastTapY);
    var isDoubleTap = now - this.lastTapTime < DOUBLE_TAP_MS && dtx < DOUBLE_TAP_SLOP && dty < DOUBLE_TAP_SLOP;

    if (isDoubleTap) {
      this.lastTapTime = 0;
      if (this.scale > 1.02) {
        this.reset();
      } else {
        var rect = this.img.getBoundingClientRect();
        var originX = ((changed.clientX - rect.left) / rect.width) * 100;
        var originY = ((changed.clientY - rect.top) / rect.height) * 100;
        this.img.style.setProperty('transform-origin', originX + '% ' + originY + '%', 'important');
        this.scale = DOUBLE_TAP_SCALE;
        this.translateX = 0;
        this.translateY = 0;
        this.apply();
      }
    } else {
      this.lastTapTime = now;
      this.lastTapX = changed.clientX;
      this.lastTapY = changed.clientY;
    }
  };

  function MobileModalCarousel(modalEl) {
    this.modal = modalEl;
    this.content = modalEl.querySelector('.product-media-modal__content');
    this.counter = modalEl.querySelector('.tp-modal-counter');
    this.frames = Array.prototype.slice.call(modalEl.querySelectorAll('.tp-zoom-frame'));
    this.zoomers = this.frames.map(function (frame) {
      return new ZoomableImage(frame);
    });

    if (!this.content) return;

    this.scrollTimer = null;
    this.dragStartX = undefined;
    this.dragStartY = undefined;
    this.dragZoomed = false;

    this.onScroll = this.onScroll.bind(this);
    this.onTouchStart = this.onTouchStart.bind(this);
    this.onTouchEnd = this.onTouchEnd.bind(this);

    this.content.addEventListener('scroll', this.onScroll, { passive: true });
    this.content.addEventListener('touchstart', this.onTouchStart, { passive: true });
    this.content.addEventListener('touchend', this.onTouchEnd, { passive: true });

    document.body.addEventListener('modalClosed', this.resetAllZoom.bind(this));
  }

  MobileModalCarousel.prototype.resetAllZoom = function () {
    this.zoomers.forEach(function (zoomer) {
      if (zoomer.img) zoomer.reset();
    });
  };

  MobileModalCarousel.prototype.currentIndex = function () {
    if (!this.frames.length) return 0;
    var frameWidth = this.content.clientWidth || 1;
    return clamp(Math.round(this.content.scrollLeft / frameWidth), 0, this.frames.length - 1);
  };

  MobileModalCarousel.prototype.updateCounter = function () {
    if (!this.counter) return;
    var index = this.currentIndex();
    var current = this.counter.querySelector('.tp-modal-counter__current');
    if (current) current.textContent = index + 1;
  };

  MobileModalCarousel.prototype.onScroll = function () {
    if (!mql.matches) return;
    var self = this;
    if (this.scrollTimer) window.clearTimeout(this.scrollTimer);
    this.scrollTimer = window.setTimeout(function () {
      self.updateCounter();
      var active = self.currentIndex();
      self.frames.forEach(function (frame, index) {
        if (index !== active) {
          var zoomer = self.zoomers[index];
          if (zoomer && zoomer.img) zoomer.reset();
        }
      });
    }, 120);
  };

  MobileModalCarousel.prototype.onTouchStart = function (event) {
    if (!mql.matches) return;
    var touch = event.touches[0];
    if (!touch) return;
    this.dragStartX = touch.clientX;
    this.dragStartY = touch.clientY;
    var activeFrame = this.frames[this.currentIndex()];
    this.dragZoomed = !!(activeFrame && activeFrame.classList.contains('tp-zoomed'));
  };

  MobileModalCarousel.prototype.onTouchEnd = function (event) {
    if (!mql.matches) return;
    if (this.dragZoomed) return;
    var touch = event.changedTouches && event.changedTouches[0];
    if (!touch || this.dragStartX === undefined) return;
    var dx = touch.clientX - this.dragStartX;
    var dy = touch.clientY - this.dragStartY;
    if (Math.abs(dy) > CLOSE_DRAG_THRESHOLD && Math.abs(dy) > Math.abs(dx) * 1.5) {
      if (this.modal && typeof this.modal.hide === 'function') this.modal.hide();
    }
  };

  MobileModalCarousel.prototype.syncCounter = function () {
    this.updateCounter();
  };

  var instances = new WeakMap();

  function init() {
    document.querySelectorAll('.product-media-modal').forEach(function (modalEl) {
      if (instances.has(modalEl)) return;
      instances.set(modalEl, new MobileModalCarousel(modalEl));
    });
  }

  window.tpGalleryModal = {
    syncCounter: function (modalEl) {
      var instance = instances.get(modalEl);
      if (instance) instance.syncCounter();
    },
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
